import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';


import { AuthenticationService } from '.';
import { Video } from '../models';
import { HttpService } from './http.service';

@Injectable()
export class VideoService extends HttpService {
  public editdata: Video = <Video>{};

  getVideos(): Observable<Video[]> {
      
      let requestOptionsArgs = {};
      return this.getApi('/video', requestOptionsArgs, 'videolist')
        .map(res => <Video[]>res.json().result)
        .catch(this.handleError);
  }

  resetEditData() {
    this.editdata = <Video>{};
  }

  add(row: object): Observable<boolean> {
    row = _.assignIn({}, row);

    let requestOptionsArgs = { body: row };
    return this.postApi('/video', requestOptionsArgs, 'add-video')
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }

  edit(id:any, row: object): Observable<boolean> {
    row = _.assignIn({}, row);

    let requestOptionsArgs = { body: row };
    return this.putApi('/video/' + id, requestOptionsArgs, 'edit-video')
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }

  delete(id: string): Observable<boolean> {
    let requestOptionsArgs = {};
    return this.deleteApi('/video/' + id, requestOptionsArgs, 'delete-video')
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/video.service.ts